import type { PropsWithChildren } from 'react';
import type { AuthenticationConfig } from './authentication';
import { SessionContext, useAuthentication } from './session-hooks';

type AuthenticationProviderProps = {
  config: AuthenticationConfig;
};
export const AuthenticationProvider = ({ config, children }: PropsWithChildren<AuthenticationProviderProps>) => {
  const session = useAuthentication(config);

  return (
    <SessionContext.Provider value={session}>
      {children}
    </SessionContext.Provider>
  );
};
